/**
 * Module dependencies.
 */

import { HeroBackground } from 'src/components/landingpage/components/hero-background/hero-background';
import { HeroCallToAction } from 'src/components/landingpage/components/hero-call-to-action/hero-call-to-action';
import { HeroContent } from 'src/components/landingpage/components/hero-content/hero-content';
import styled from 'styled-components';

/**
 * `Container` styled component.
 */

const Container = styled.div`
  flex-shrink: 0;
  position: relative;
  width: 100%;
  z-index: 10;

  > div:first-child {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-inline: auto;
    max-width: 1440px;
    min-height: inherit;
    width: 100%;

    > div {
      align-items: center;
      box-sizing: border-box;
      content: stretch;
      display: flex;
      flex-direction: column;
      min-height: inherit;
      padding: 104px 72px 156px;
      position: relative;
      width: 100%;

      @media (max-width: 1119px) {
        padding-left: 32px;
        padding-right: 32px;
      }

      @media (max-width: 419px) {
        padding-bottom: 90px;
      }
    }
  }
`;

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 12;
`;

/**
 * Export `HeroSection` component.
 */

export function HeroSection() {
  return (
    <Wrapper>
      <HeroBackground />

      <Container data-name={'section-hero'} id={'section-hero'}>
        <div>
          <div>
            <HeroContent />

            <HeroCallToAction />
          </div>
        </div>
      </Container>
    </Wrapper>
  );
}
